<template>
  <div class="tab-container">
    <!--<div class="left">-->
    <!--<span class="tran-all icon iconfont icon-shuangjiantouzuo"></span>-->
    <!--</div>-->
    <div class="div">
      <div v-for="(item,index) in list" :key="index" class="item tran-all"
        :class="item.active?'active':''">
        <div>
          <b class="c-pointer" @click="gotoPage(index)">{{item.pageMenu}}</b>
          <span v-if="item.index1!==0||item.index2!==0" @click="delPage(index)"
            class="c-pointer el-icon-close"></span>
        </div>
      </div>
    </div>
    <!--<div class="right">-->
    <!--<span class="icon iconfont icon-shuangjiantouyou tran-all"></span>-->
    <!--</div>-->
  </div>
</template>

<script type="text/ecmascript-6">
import { tool } from "../../common/js/tool.js";
export default {
  data() {
    return {
      list: []
    };
  },
  computed: {
    getTabs() {
      return this.$store.getters.getTabs;
    },
    getTabActive() {
      return this.$store.getters.getTabActive;
    }
  },
  created() {
    this.list = this.$store.getters.getTabs;
    //this.list.unshift({pageMenu: '首页', index1: 0, index2: 0, pageUrl: '/home', active: true})
    console.log(this.list);
  },
  methods: {
    gotoPage(index) {
      console.log(this.getTabActive);
      let list = [...this.list];
      console.dir(list);
      console.dir(list[index].index1 + "-" + list[index].index2);
      if (this.getTabActive === list[index].index1 + "-" + list[index].index2) {
        return;
      }
      for (let i = 0; i < list.length; i++) {
        list[i]["active"] = false;
      }
      list[index].active = true;
      this.$store.commit("setTabs", list);
      this.$store.commit(
        "setTabActive",
        list[index].index1 + "-" + list[index].index2
      );
      this.$router.push({ path: list[index].pageUrl });
    },
    delPage(index) {
      let list = [...this.$store.getters.getTabs];
      if (
        list[index].index1 + "-" + list[index].index2 !==
        this.$store.getters.getTabActive
      ) {
        list.splice(index, 1);
        this.list = this.$store.getters.getTabs;
      } else {
        //tool.message('不能关闭当前页', 'error');
        let list = [...this.$store.getters.getTabs];
        list.splice(index, 1);
        console.log(index, list.length);
        if (index < list.length) {
          this.$store.commit(
            "setTabActive",
            list[index].index1 + "-" + list[index].index2
          );
          setTimeout(() => {
            list[index].active = true;
            this.$store.commit("setTabs", list);
            this.$router.push({
              path: this.$store.getters.getTabs[index].pageUrl
            });
          }, 10);
        } else {
          this.$store.commit(
            "setTabActive",
            list[index - 1].index1 + "-" + list[index - 1].index2
          );
          setTimeout(() => {
            list[index - 1].active = true;
            this.$store.commit("setTabs", list);
            this.$router.push({
              path: this.$store.getters.getTabs[index - 1].pageUrl
            });
          }, 10);
        }
      }
      this.$store.commit("setTabs", list);
    }
  },
  watch: {
    getTabs(a, b) {
      if (a !== b || a.length !== b.length) {
        setTimeout(() => {
          this.list = this.$store.getters.getTabs;
          console.log(this.list);
        }, 10);
      }
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
@import "../../common/less/variable.less";

.tab-container {
  overflow: hidden;
  height: @tabHeight;
  width: 100%;
  display: flex;
  background: #f6f6f6;
  border-top: 5px solid #f6f6f6;
  box-sizing: content-box;
  .div {
    flex: 1;
    height: @tabHeight;
    margin-left: 14px;
    overflow: hidden;
    .item {
      height: @tabHeight;
      line-height: @tabHeight;
      padding: 0 10px;
      color: #a1a1a1;
      float: left;
      position: relative;
      background: #f6f6f6;
      margin-right: 1px;
      transform: skew(20deg);
      &:first-child {
        padding: 0 20px;
        margin-left: -10px;
      }
      div {
        transform: skew(-20deg);
      }
      b {
        color: #a1a1a1;
        display: inline-block;
      }
      span {
        font-size: 10px;
        color: #a1a1a1;
        margin-left: 3px;
        /*opacity: 0;*/
      }
      &.active,
      &:hover {
        background: white;
        color: @colorBlue;
        b {
          color: @colorBlue;
        }
      }
      &:hover {
        span {
          opacity: 1;
        }
      }
    }
  }
  .left,
  .right {
    width: @tabHeight;
    height: @tabHeight;
    display: flex;
    justify-content: center;
    align-items: center;
    /*background: white;*/
    /*border: 1px solid #eff0f5;*/
    border-top: none;
    color: white;
    cursor: pointer;
    &.left {
      float: left;
    }
    &.right {
      float: right;
    }
    &:hover {
      span {
        transform: scale(0.8);
      }
    }
  }
}
</style>